module.exports = __webpack_public_path__ + "img/user_icon.3ffd464e.png";